import { defineMessages } from 'react-intl';

export default defineMessages({
    bannerDescription: {
        defaultMessage:
            'Apps have been blocked by your administrator in this project through a data\n' +
            '                security policy. If there is something you are looking for that you can no longer\n' +
            '                see, this may be because the app is blocked. For any questions, reach out to\n' +
            '                your organization admin.',
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description',
    },
    doNotShow: {
        defaultMessage: "Don't show again",
        description:
            'Do not show again link. When the user clicks on this, he will not see the blocked apps banner again',
        id: 'sd.portal.blocked.app.banner.doNotShow',
    },
    learnMore: {
        defaultMessage: 'Learn more about apps which are blocked',
        description: 'This is a link that the users can click to learn about blocked apps',
        id: 'sd.portal.blocked.app.banner.learnMore',
    },
});
